import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import style from "./Modal.module.css";
import moment from "moment";
import {
    Row,
    Col,
    Button,
    Card,
    Table,
    Form,
    Container,
    Modal,
    Tabs,
    Tab,
} from "react-bootstrap";
import { FaTachometerAlt, FaCalendarAlt, FaUsers, FaUser, FaArrowRight, FaSpinner, FaLifeRing, FaUndoAlt, FaPen } from "react-icons/fa"; // Import Calendar Icon
import { FaCircleStop, FaCloudArrowDown, FaHand, FaBan, FaS} from "react-icons/fa6";
import { apiCall } from "../api/apiUtil";

function BusinessInterestEmpDashboard() {
    const [vendorCode, setVendorCode] = useState(null);
    const [finYear, setFinYear] = useState("");
    const [businessInterestList, setBusinessInterestList] = useState([]);
    const [businessInterestId, setBusinessInterestId] = useState(null);
    const [showEmployeeActionModal, setShowEmployeeActionModal] = useState(false);
    const [isModalFormSubmissionStatus, setIsModalFormSubmissionStatus] = useState(false);
    const [employeeAckStatus, setEmployeeAckStatus] = useState(null);
    const [employeeResponse, setEmployeeResponse] = useState("");

    const getFinancialYear = (date) => {
        const year = date.getFullYear();
        const month = date.getMonth(); // 0 = Jan
        let fy = "";
        
        if (month >= 3) { // April or later
            fy = `${year}-${(year + 1).toString().slice(-2)}`;
        } else {
            fy = `${year - 1}-${year.toString().slice(-2)}`;
        }
        setFinYear(fy);        
        return fy;
    };

    const [selectedMonth, setSelectedMonth] = useState(() => {
        const today = moment();
        // // Get Current week's Monday
        // const currentMonday = moment().startOf('week').add(1, 'day');
        // // Get Current week's Sunday
        // const currentSunday = moment(currentMonday).add(6, 'days'); // this Monday + 6 = Current Sunday
        // // Build this month's 24th date
        // const thisMonth24th = moment().date(24);
        // const is24thInRange = thisMonth24th.isSameOrAfter(currentMonday, 'day') && thisMonth24th.isSameOrBefore(currentSunday, 'day');
        
        getFinancialYear(today.toDate());

        return today.toDate();
    });

    const navigate = useNavigate();

    useEffect(() => {
        let vendorCode = sessionStorage.getItem("vendorCode");
        setVendorCode(vendorCode);
        if(vendorCode) {
            getAcknowledgements(vendorCode);
        } else {
            navigate("/");
        }
    }, [navigate]);

    const getAcknowledgements = (vendorCode) => {
        apiCall(`/VendorCompliance/GetVendorRelations/vendor-pov/${vendorCode}/${finYear}` , {
            method: "GET"
        })
        .then((response) => {
            let data = response;
            //console.log("Backend Response:", data);
            setBusinessInterestList(data ?? []);
        })
        .catch((err) => {
            alert(err);
            console.error("Error:", err);
        });
    };    

    return (
        <div className="d-flex flex-column min-vh-100">
            <Container className="flex-grow-1 mt-3 mb-3">
                <div className="row">
                    <div className="col bg-light mb-2 d-flex justify-content-between align-items-center">
                        <h5 className="mt-1">
                            <FaTachometerAlt className="me-2" /> Vendor Business Interest Status
                        </h5>
                    </div>
                    <div className="gap-2 ms-auto" style={{width: "250px"}}>
                        <label className="align-items-center">Financial Year: {finYear}</label>
                        {/* Month Picker with Calendar Icon inside Input */}
                        <div className="position-relative">
                            <DatePicker selected={selectedMonth} onChange={(date) => setSelectedMonth(date)} dateFormat="MMMM yyyy" showMonthYearPicker className="form-control pe-5" />
                            {/* Calendar Icon Inside Input */}
                            <FaCalendarAlt className="position-absolute text-muted"
                                style={{
                                    top: 20,
                                    right: "10px",
                                    transform: "translateY(-50%)",
                                    fontSize: "1.2rem",
                                    cursor: "pointer",
                                }}
                                onClick={() =>
                                    document
                                        .querySelector(".react-datepicker__input-container input")
                                        .focus()
                                } // Trigger DatePicker on click
                            />
                            {/* <span style={{fontSize: "13px", color: "red"}}>24th of {moment(selectedMonth).subtract(1, "M").format("MMMM YYYY")} to 23rd of {moment(selectedMonth).format("MMMM YYYY")}</span> */}
                        </div>
                        {/* <Button variant="success" size="sm">
                            Completed
                        </Button> */}
                    </div>
                </div>
                <br />
                <div className="d-flex justify-content-end">
                    <a href="/vendor-dashboard" className="me-3">
                        <Button variant="warning" size="sm">
                            <FaUser className="me-2" /> Dashboard
                        </Button>
                    </a>
                </div>
                <Card>
                    <Card.Body>
                        <div className="table-responsive">
                            <Table striped bordered hover className="mt-3">
                                <thead>
                                    <tr>
                                        <th>Org Unit</th>
                                        <th>Vendor Code</th>
                                        <th>Vendor Name</th>
                                        <th>Unit</th>
                                        <th>Category <br /> Month</th>
                                        <th>Reconcile Status</th>
                                        <th>Acknowledgement Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(businessInterestList) && businessInterestList.map((interest, index) => (
                                        <tr>
                                            <td>{interest?.orgUnit}</td>
                                            <td>{interest?.vendorCode}</td>
                                            <td>{interest?.vendorName}</td>
                                            <td>{interest?.unit}</td>
                                            <td>{interest?.category}<br />{interest?.month} - {interest?.year}</td>
                                            <td className="text-center">
                                                {(interest?.reconcileStatus == null) && (<Button variant="warning" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
                                                {(interest?.reconcileStatus == true) && (<Button variant="success" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
                                                {(interest?.reconcileStatus == false) && (<Button variant="danger" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
                                            </td>
                                            <td className="text-center">
                                                {(interest?.employeeAck == null) && (<Button variant="warning" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
                                                {(interest?.employeeAck == true) && (<Button variant="success" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
                                                {(interest?.employeeAck == false) && (<Button variant="danger" size="sm" style={{width: 20, height: 20, borderRadius: "50%"}}> </Button>)}
                                            </td>
                                        </tr>
                                    ))}
                                    {(Array.isArray(businessInterestList) && businessInterestList.length === 0) && 
                                        (
                                            <tr>
                                                <td colSpan="7" className="text-center text-muted">
                                                No records found
                                                </td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </div>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
    
}

export default BusinessInterestEmpDashboard;